import { refreshSession } from "./ApiUtils/ApiUtils";

export function getUID() {
    var d = new Date();
    return btoa((Math.round(Math.random() * 1000000)).toString() + d.getMilliseconds().toString() + (Math.round(Math.random() * 1000000)).toString());
}

/**
 * Client-side login check. Mirrors how ApiUtils and Login.tsx decide auth
 * state: the server sets a non-HTTP-only `gdscp_userAuthenticated` marker
 * cookie on token issue and clears it on logout. Returns true only when the
 * cookie is present with a non-empty value.
 */
export function isAuthenticated(): boolean {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; gdscp_userAuthenticated=`);
    if (parts.length === 2) {
        return !!parts.pop()?.split(';').shift();
    }
    return false;
}

/**
 * Per-card role-loading status for the roles page. Each client card renders
 * two independent role grids that fetch asynchronously: `default` (default
 * roles) and `client` (client roles).
 */
export type CardRoleLoadStatus = { default: boolean; client: boolean };

/**
 * A roles-page card is still loading until BOTH of its role sections have
 * reported that their fetch finished. An unrecorded card (undefined) is
 * treated as still loading.
 */
export function isCardContentLoading(status?: CardRoleLoadStatus): boolean {
    return !(status?.default === true && status?.client === true);
}

export function stringToObjectKey(pString:string) {
   const regex = /[^A-Z0-9]+/gmi;
   const subst = "_";
   return pString.replace(regex, subst).toUpperCase();
}

export const setupSessionIdleRefresh = () => {
    localStorage.setItem('lastApiRequestDateTime', new Date().toISOString());
    const refreshFrequencyMinute = 5;

    document.addEventListener('click', () => {
        const last = localStorage.getItem('lastApiRequestDateTime') ?? new Date().toISOString();
        const now = new Date();
        const diff = now.getTime() - new Date(last).getTime();

        if (diff > refreshFrequencyMinute * 60000) {
            localStorage.setItem('lastApiRequestDateTime', now.toISOString());

            refreshSession().then((response) => {
                const isSuccess = response.data.success;

                if (isSuccess) {
                    console.info("Refresh OK");
                }

            }).catch(err => console.error("Session refresh error:", err));
        }
    });
};